import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const QUOTE_STATUS_SCHEMA = order.orderService.versions.v1.schemas.QUOTE_STATUS_SCHEMA;

export const ACTIVE_QUOTE_STATUS_SCHEMA = QUOTE_STATUS_SCHEMA.exclude([QUOTE_STATUS_SCHEMA.enum.CANCELED]);

export type ACTIVE_QUOTE_STATUS = z.infer<typeof ACTIVE_QUOTE_STATUS_SCHEMA>;
export type QUOTE_STATUS = z.infer<typeof QUOTE_STATUS_SCHEMA>;
